import {version as immerVersion} from 'immer/package.json';

import {recordRumDurationVital} from '../datadogRum';

export const VIEWS_REDUCER_PERFORMANCE_MIN_DURATION_MS = 2;

type ViewsReducerImplementation = 'immer' | 'immutable';

const normalizeActionType = (actionType: string): string =>
  actionType
    .replace(/^@+/, '')
    .replace(/[^a-zA-Z0-9]+/g, '.')
    .replace(/^\.|\.$/g, '');

export function startViewsReducerPerformanceMeasure(
  implementation: ViewsReducerImplementation,
  actionType: string
): () => void {
  const startMark = performance.now();
  let finished = false;

  return () => {
    if (finished) {
      return;
    }
    finished = true;

    const duration = performance.now() - startMark;
    if (duration <= VIEWS_REDUCER_PERFORMANCE_MIN_DURATION_MS) {
      return;
    }

    const implementationDescription =
      implementation === 'immer' ? 'Immer' : implementation;
    recordRumDurationVital(
      `workspace.${implementation}.${normalizeActionType(actionType)}`,
      {
        startTime: performance.timeOrigin + startMark,
        duration,
        description: `synchronous views ${implementationDescription} duration for ${actionType}`,
        context: {
          actionType,
          ...(implementation === 'immer' ? {immerVersion} : {}),
          reducer: 'views',
        },
      }
    );
  };
}
